import React from 'react'
import { Avatar, Button, ToggleSwitch, Tooltip } from '@enamelai/design-system'

interface InsuranceActionProps {
  /** Page tabs rendered at the start of the toolbar. */
  tabs?: React.ReactNode
  handleAddInsuranceClick: () => void
  onSubmitClaim: () => void
  hasInsurancePlan: boolean
  familyMembersInfo?: {
    familyMembers: any[]
    showFamilyMembers: boolean
    setShowFamilyMembers: (showFamilyMembers: boolean) => void
    selectedFamilyMemberId: any
    setSelectedFamilyMemberId: (selectedFamilyMemberId: string) => void
  }
  disabled?: boolean
}

const FAMILY_TOGGLE_ID = 'show-family-members-switch'

const InsuranceAction: React.FC<InsuranceActionProps> = ({
  tabs,
  handleAddInsuranceClick,
  onSubmitClaim,
  hasInsurancePlan,
  familyMembersInfo,
  disabled = false,
}) => {
  return (
    <div className="insurance-toolbar section-insurance-actions">
      <div className="insurance-toolbar__start">
        {tabs}
        {familyMembersInfo && (
          <div className="insurance-family">
            <ToggleSwitch
              id={FAMILY_TOGGLE_ID}
              aria-label="Show family members"
              checked={familyMembersInfo.showFamilyMembers}
              onChange={familyMembersInfo.setShowFamilyMembers}
            />
            <label
              className="insurance-family__label"
              htmlFor={FAMILY_TOGGLE_ID}
            >
              Show family members
            </label>
            {familyMembersInfo.showFamilyMembers && (
              <div className="insurance-family__members">
                {familyMembersInfo.familyMembers.map((member) => {
                  const fullName = `${member.first_name} ${member.last_name}`
                  const isSelected =
                    member.member_id ===
                    familyMembersInfo.selectedFamilyMemberId
                  return (
                    <Tooltip
                      key={member.member_id ?? member.patient_id}
                      content={`${fullName} · ${member.relation_to_patient}`}
                      placement="bottom"
                      portal
                    >
                      <button
                        type="button"
                        className={`insurance-family__member${
                          isSelected
                            ? ' insurance-family__member--selected'
                            : ''
                        }`}
                        aria-label={`Select ${fullName}`}
                        aria-pressed={isSelected}
                        onClick={() =>
                          familyMembersInfo.setSelectedFamilyMemberId(
                            member.member_id,
                          )
                        }
                      >
                        <Avatar
                          name={fullName}
                          src={member?.photo_file?.file_path ?? member?.photo}
                          alt=""
                          size={32}
                        />
                      </button>
                    </Tooltip>
                  )
                })}
              </div>
            )}
          </div>
        )}
      </div>
      <div className="insurance-toolbar__actions">
        <Button
          variant="secondary"
          size="md"
          onClick={onSubmitClaim}
          disabled={!hasInsurancePlan || disabled}
        >
          Submit claim
        </Button>
        <Button
          variant="primary"
          size="md"
          onClick={handleAddInsuranceClick}
          disabled={disabled}
        >
          Add plan
        </Button>
      </div>
    </div>
  )
}

export default InsuranceAction
